import React, { useEffect, useState } from 'react';
import { Button, Result } from 'antd';
import { error } from 'console';
import { ExceptionStatusType, ResultStatusType } from 'antd/es/result';

type Props = {
    status: any,
    title: any,
    subTitle: any,
    button: any,
    messageError: any
  }

  

const ErrorPage = (props: Props) => {
    const {status, title, subTitle, button, messageError}= props;
    const [errorTitle, setErrorTitle] = useState("404");
    const [errorSubtitle, setErrorSubtitle] = useState<String>("404");
     const [errorStatus, setErrorStatus] = useState<ExceptionStatusType | ResultStatusType> (404)

     useEffect(()=>{

      if(499 < status && status < 600){
      setErrorStatus(500)
      setErrorTitle("An Internal Server Error Occurred");
      setErrorSubtitle("An Internal Server Error Occurred")
    }
    else if (status === 403){
      setErrorStatus(403)
      setErrorTitle("Sorry, you are not authorized to access this page.");
      setErrorSubtitle("Sorry, you are not authorized to access this page.");
    }

    else if (399 < status && status < 499){
      setErrorStatus(403)
      setErrorTitle("Sorry, the page you visited does not exist.");
      setErrorSubtitle("Sorry, the page you visited does not exist.");
    }

    else if ( status === "noresults"){
      setErrorStatus(404)
      setErrorTitle("No Results Found!");
      setErrorSubtitle("Sorry, the page you visited does not exist.");
    }
    else {
      setErrorStatus('warning')
      setErrorTitle("Unknown Error Occured");
      setErrorSubtitle("Unknown Error Occured");
    }
    
  }, [status])

    
    return (
        !status ? <></> :
  <Result
    status={errorStatus}
    title={errorTitle}
    // subTitle={errorSubtitle}
    extra={button ? <><Button type="primary">Back Home</Button> 
    <Button target='_blank' href={`https://wa.me/8619539307?text=${messageError}`} type="primary">Notify Us</Button></> : undefined}
  />
    )
    };

export default ErrorPage;